import type { DatabaseEngineId } from '@/core/engines';
import type { SqlSnippetTemplate } from './sqlSnippetTemplateTypes';
import { getBuiltInSqlSnippetTemplatesDdlCreate } from './builtInSqlSnippetTemplatesDdlCreate';
import { getBuiltInSqlSnippetTemplatesDdlAlterDrop } from './builtInSqlSnippetTemplatesDdlAlterDrop';

export function getBuiltInSqlSnippetTemplatesDdl(engineId: DatabaseEngineId): readonly SqlSnippetTemplate[] {
  return [
    ...getBuiltInSqlSnippetTemplatesDdlCreate(engineId),
    ...getBuiltInSqlSnippetTemplatesDdlAlterDrop(engineId),
  ] as const;
}
